
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockSkuGrid extends Serenity.EntityGrid<IcStockSkuRow, any> {
        protected getColumnsKey() { return IcStockSkuColumns.columnsKey; }
        protected getDialogType() { return IcStockSkuDialog; }
        protected getIdProperty() { return IcStockSkuRow.idProperty; }
        protected getInsertPermission() { return IcStockSkuRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockSkuRow.localTextPrefix; }
        protected getService() { return IcStockSkuService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}